
import { TrackingService } from 'sharebase/services/trackingService';
const template = require('./register.template');
require('./register.styles');

export function RegisterDirective(): ng.IDirective {
    return {
        restrict: 'E',
        controller: RegisterDirectiveController,
        controllerAs: 'vm',
        scope: { },
        bindToController: {
            deploymentId: '@',
            authToken: '@'
        },
        template
    };
}

class RegisterDirectiveController {
    public static readonly $inject: string[] = [
        '$sce',
        '$mdMedia',
        'pxEnvironmentService',
        'sbTrackingService',
        'settingsService'
    ];

    public readonly termsOfUsePath: string;
    public readonly deploymentId: string;
    public readonly authToken: string;

    constructor(
            $sce: ng.ISCEService, 
            private readonly $mdMedia: any, 
            env: any, 
            sbTrackingService:TrackingService, 
            settingsService: any
        ) {
        let base = settingsService.serverLegalPath;
        if (env.legalLanguage !== 'en') {
            base += `/${env.legalLanguage}`;
        }
        
        sbTrackingService.trackClick('Creating Customer Deployment Started');
        this.termsOfUsePath = $sce.trustAsResourceUrl(`${base}/terms-of-service/index.htm`);
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/register/register.ts